import type { ReactNode } from "react"

export function RedOutline({ children }: { children: ReactNode }) {
  return (
    <div className="rounded-sm px-2 py-1 outline-2 outline-red-200 outline-solid">{children}</div>
  )
}
